// extracted by mini-css-extract-plugin
export default {"button":"button_button__zpxkc","primary":"button_primary__ORBqv","secondary":"button_secondary__B668O"};